<template>
  <div>
    <div class="plans">
      <VRadioGroup :value="selectedPlan?.id">
        <!-- Plans 1 -->
        <div v-for="plan in plans" :key="plan.id" class="plan" :class="{ selected: plan.id === selectedPlan?.id }" @click="handleSelectPlan(plan)">
          <div class="text">
            <VRadio :value="plan.id" />

            <div class="description">{{ plan.title }}</div>
            <div v-if="cycle === 'YEARLY' && plan.annual_discount" class="discount">
              <VIcon color="#E8663D">mdi-brightness-percent</VIcon>
              <div>-R$ {{ Number(plan.annual_discount).toFixed(2).toString().replace('.00', '') }}</div>
            </div>
            <div v-if="plan?.code === 'custom'" class="contact">
              <VIcon color="primary">mdi-whatsapp</VIcon>
              <div>Fale conosco</div>
            </div>
            <div v-else-if="plan?.free_for_days" class="price">{{ plan.free_for_days }} dias grátis</div>
            <div v-else class="price">R$ {{ handleCalculateDiscount(plan) }} <span>/mês</span></div>
          </div>
        </div>
      </VRadioGroup>
    </div>

    <template v-if="selectedPlan">
      <div class="section-header">Veja o que está incluso</div>
      <SignatureIncludedItems :title="selectedPlan.title" :description="selectedPlan.description" :plan="selectedPlan" />
    </template>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import SignatureIncludedItems from './IncludedItems/SignatureIncludedItems';

export default {
  name: 'SignaturePlans',
  components: { SignatureIncludedItems },
  computed: {
    ...mapState('Payment', ['selectedPlan', 'cycle', 'plans'])
  },
  methods: {
    ...mapActions('Payment', ['setSelectedPlan']),
    handleSelectPlan(plan) {
      this.setSelectedPlan(plan);
    },
    handleCalculateDiscount(plan) {
      if (this.cycle === 'YEARLY' && plan.annual_discount) {
        return (plan.price - plan.annual_discount / 12).toFixed(2);
      }

      return plan.price;
    }
  }
};
</script>

<style lang="scss">
.plan {
  background-color: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid #fff;
  cursor: pointer;
  &:hover {
    border-color: #d9d8de;
  }
  &.selected {
    border-color: #48b48d;
  }

  .v-radio {
    margin-bottom: 0 !important;
  }

  .contact {
    display: flex;
    gap: 4px;
    align-items: center;
    font-weight: 700;
    color: #48b48d;
  }

  .text {
    color: #3f505f;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    .description {
      flex-grow: 1;
      font-size: 14px;
      font-weight: 600;
    }

    .price {
      font-weight: 700;
      span {
        font-weight: normal;
      }
    }

    .discount {
      color: #e8663d;
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 4px;
      padding-right: 15px;
    }
  }
}
</style>
